import axios from './AxiosInstance'

export default {
  fetchHistories: ({ limit, offset }) => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/call_history/list',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        params: { limit: limit, offset: offset },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addAttendee: ({ phoneCallID, attendeeNPID }) => {
    var formData = new FormData()
    formData.append('phone_call_id', phoneCallID)
    formData.append('attendee_id', attendeeNPID)
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/phone_call/add_attendee',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token,
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  }
}